module.exports = new __parcel__URL__("frostlance.dbd343ae.png").toString();